import HeroSection from "@/components/home/HeroSection";
import Marquee from "@/components/Marquee";
import { ServicesBento, MetricsBand, CaseStudies, Manifesto, Testimonials, CTABand } from "@/components/home/HomeSections";

export default function Home() {
  return (
    <div data-testid="home-page">
      <HeroSection />
      <Marquee />
      <ServicesBento />
      <MetricsBand />
      <CaseStudies />
      <Manifesto />
      <Testimonials />
      <CTABand />
    </div>
  );
}
